export const richTextConfig = {
    name: 'RichText',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/69669f518ad79cb2a6946a7ae09fccc4.svg',
    inputs: [
        {
            name: 'html',
            friendlyName: 'Text',
            type: 'richText',
        },
        {
            name: 'disableDefaultStyles',
            type: 'boolean',
            defaultValue: false,
        },
    ],
};
//# sourceMappingURL=config.js.map